import React, { forwardRef } from 'react';
import { Turnstile } from '@marsidev/react-turnstile';

// Cloudflare Turnstile wrapper. No-op when REACT_APP_TURNSTILE_SITE_KEY is unset.
// Parent holds a ref and calls ref.current.reset() to get a fresh single-use token.
const TurnstileWidget = forwardRef(function TurnstileWidget({ action, onToken }, ref) {
  const siteKey = process.env.REACT_APP_TURNSTILE_SITE_KEY;
  if (!siteKey) return null;

  return (
    <div data-testid={`turnstile-${action}`} className="flex justify-center">
      <Turnstile
        ref={ref}
        siteKey={siteKey}
        options={{
          action,
          size: 'flexible',
          appearance: 'interaction-only',
          refreshExpired: 'auto',
          retry: 'auto',
        }}
        onSuccess={(token) => onToken(token)}
        onError={() => onToken(null)}
        onExpire={() => onToken(null)}
      />
    </div>
  );
});

export default TurnstileWidget;
